import React from 'react';
import { InfoLabel, Box, Button } from '../../../../common/components';
import getIncludedResource from '../../../../helpers/getIncludedResource';
import displayAddress from '../../../../helpers/displayAddress';
import { reactivateUser, deactivateUser } from '../../redux/userActions';
import displayName from '../../../../helpers/displayName';
import { Col, Row } from 'react-bootstrap';
import { InternalButtonBar } from '../../../layout/components';
//import SwitchBrokerModal from './components/SwitchBrokerModal/SwitchBrokerModal';
import { connect, useSelector } from 'react-redux';
import ResetPasswordButton from './components/ResetPasswordButton/ResetPasswordButton';

const getButtons = (
  resource,
  isReactivating,
  isDeactivating,
  onReactivateUser,
  onDeactivateUser,
) => {
  const resourceAttributes = resource?.data?.attributes;
  const isContact = resourceAttributes.status === 'contact';
  const resourceId = resource.data.id;
  const editUrl = isContact ? '/edit?contact=true' : '/edit';
  const displayName = isContact ? 'Contact' : 'User';

  const userButtons = [
    {
      permissions: ['user.edit'],
      button: (
        <Button
          link={true}
          to={`/admin/users/${resourceId}${editUrl}`}
          className="pull-right"
          bsStyle="primary"
          rightIcon="pencil-square-o"
          label={`Edit ${displayName}`}
        />
      ),
    },
    {
      statuses: ['active', 'pending'],
      permissions: ['user.view'],
      button: <ResetPasswordButton resource={resource} />,
    },
    {
      statuses: ['inactive'],
      permissions: ['user.edit'],
      button: (
        <Button
          className="pull-right"
          bsStyle="primary"
          rightIcon="check"
          isLoading={isReactivating}
          handleClick={onReactivateUser}
          label="Reactivate User"
        />
      ),
    },
    {
      statuses: ['active'],
      permissions: ['user.edit'],
      button: (
        <Button
          className="pull-right"
          bsStyle="primary"
          rightIcon="ban"
          isLoading={isDeactivating}
          handleClick={onDeactivateUser}
          label="Deactivate User"
        />
      ),
    },
    // {
    //   permissions: ['user.edit'],
    //   button: (
    //     <SwitchBrokerModal resource={resource}/>
    //   )
    // }
  ];

  return userButtons.filter((button) => {
    return !(
      button.statuses && button.statuses.indexOf(resourceAttributes.status) === -1
    );
  });
};
const UserDetails = ({ resource, onReactivateUser, onDeactivateUser }) => {
  const { isReactivating, isDeactivating } = useSelector((state) => state?.user);

  const currentOrganisation = getIncludedResource(
    resource.data,
    resource.included,
    'current_organisation',
  );

  const organisation = getIncludedResource(
    resource.data,
    resource.included,
    'organisations',
  );
  const currentBroker = getIncludedResource(
    resource.data,
    resource.included,
    'current_broker',
  );

  const reactivateUser = () => {
    onReactivateUser(resource.data.id);
  };

  const deactivateUser = () => {
    onDeactivateUser(resource.data.id);
  };

  const resourceAttributes = resource.data.attributes;
  const phoneExtension = resourceAttributes.metadata?.phone_extension;

  const organisations = Array.isArray(organisation)
    ? organisation.map((org) => org?.attributes?.name)?.join(', ')
    : '';

  const buttons = getButtons(
    resource,
    isReactivating,
    isDeactivating,
    reactivateUser,
    deactivateUser,
  );

  return (
    <Box>
      <h2 className="resource-name">{resourceAttributes.full_name}</h2>
      <Row>
        <Col sm={6}>
          <InfoLabel label="Name" value={resourceAttributes.full_name} labelSize={4} />
          <InfoLabel
            label="Address"
            value={displayAddress(resourceAttributes?.address)}
            labelSize={4}
          />
          <InfoLabel
            label="Email"
            value={resourceAttributes.email}
            labelSize={4}
            isLowerCase
          />
          <InfoLabel label="Phone" value={resourceAttributes.phone1} labelSize={4} />
          <InfoLabel
            label="Mobile Number"
            value={resourceAttributes.phone2}
            labelSize={4}
          />
          {phoneExtension && (
            <InfoLabel
              label="Phone Ext"
              value={resourceAttributes.metadata?.phone_extension}
              labelSize={4}
            />
          )}
        </Col>

        <Col sm={6}>
          <InfoLabel label="Organisations" value={organisations} labelSize={4} />
          <InfoLabel
            label="Current Organisation"
            value={currentOrganisation?.data?.attributes?.name}
            labelSize={4}
          />
          <InfoLabel
            label="Current Broker"
            value={currentBroker?.data?.attributes?.name}
            labelSize={4}
          />
          <InfoLabel label="Position" value={resourceAttributes.position} labelSize={4} />
          <InfoLabel
            label="Status"
            value={displayName(resourceAttributes.status)}
            labelSize={4}
          />
          <InfoLabel
            label="Created At"
            date
            value={resourceAttributes.created_at}
            labelSize={4}
          />
          <InfoLabel
            label="Updated At"
            date
            value={resourceAttributes.updated_at}
            labelSize={4}
          />
        </Col>
      </Row>

      <Row>
        <Col sm={12}>
          <InternalButtonBar buttons={buttons} />
        </Col>
      </Row>
    </Box>
  );
};

export default connect(
  null,
  {
    onReactivateUser: reactivateUser,
    onDeactivateUser: deactivateUser,
  },
)(UserDetails);
